import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'bg-primary-100/70',
    text: 'text-primary-700',
    iconBg: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100/70',
    text: 'text-accent-700',
    iconBg: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100/70',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-500',
  },
};

export default function CategoryShowcase() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大内容板块，涵盖百合文化的方方面面，总有一个你感兴趣的角落
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-12 h-12 rounded-xl ${colors.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-xl text-background-50`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span>浏览更多</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}